import React, { Component } from 'react'
import injectSheet from 'react-jss'
import 'hamburgers/dist/hamburgers.min.css'
import style from './style'

/**
 * A profile icon and menu.
 */

class HambugerMenu extends Component {
  constructor (props) {
    super(props)
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick (e) {
    const { onClick } = this.props
    if (onClick) onClick()
  }

  render () {
    const { handleClick } = this
    const { classes, isActive } = this.props

    let className = `${classes.base} hamburger hamburger--spring`
    if (isActive) className = `${className} is-active`

    return (
      <button className={className} type="button" onClick={handleClick}>
        <span className="hamburger-box">
          <span className="hamburger-inner" />
        </span>
      </button>
    )
  }
}

const styleAndTheme = () => style

export default injectSheet(styleAndTheme)(HambugerMenu)
